import React from 'react';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { SelectedRowsWrapper, SelectedRowsBox, SelectedRowsCount, Clear, Copy, } from './selected-rows-info.styles';
export var SelectedRowsInfo = function (_a) {
    var selectedRowsNumber = _a.selectedRowsNumber, onClearRowsSelection = _a.onClearRowsSelection, onCopySelectedRows = _a.onCopySelectedRows;
    return (React.createElement(SelectedRowsWrapper, null,
        React.createElement(SelectedRowsBox, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.2 } },
            React.createElement(SelectedRowsCount, null,
                React.createElement(BodyText, { variant: "body2" },
                    selectedRowsNumber,
                    " ",
                    selectedRowsNumber > 1 ? 'rows' : 'row',
                    ' ',
                    "selected")),
            React.createElement(Clear, { onClick: onClearRowsSelection, "data-testid": "clear-selection-btn" },
                React.createElement(BodyText, { variant: "body2", fontWeight: "bold", color: colors.blue[500] }, "Clear")),
            React.createElement(Copy, { onClick: onCopySelectedRows, "data-testid": "copy-selection-btn" },
                React.createElement(BodyText, { variant: "body2", fontWeight: "bold", color: colors.white[500] }, "Copy Data")))));
};
